module.exports = __webpack_public_path__ + "img/webperf-to-the-core.cf0ed70b.png";